import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { ResponsiveBlockGrid } from "../../../shared/components/ResponsiveBlockGrid/ResponsiveBlockGrid";
import { ResponsiveBlockGridItem } from "../../../shared/components/ResponsiveBlockGridItem/ResponsiveBlockGridItem";
import { ImageContentGridCard } from "../ImageContentGridCard/ImageContentGridCard";
import type { IImageContentGridImageBottomProps } from "./ImageContentGridImageBottom.props";

export const ImageContentGridImageBottom = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  imageAspectRatio,
  items,
  spacing,
}: IImageContentGridImageBottomProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description || buttons?.length);
  const effectiveAspectRatio = imageAspectRatio ?? "16:9";

  return (
    <BlockContainer anchorId={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-12 md:gap-16">
        {hasCommonContent ? (
          <div className="flex flex-col gap-8">
            <BlockCommonContent
              alignment={alignment}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
              headingLevel="h2"
            />
            {buttons?.length ? <BlockActions actions={buttons} alignment={alignment} /> : null}
          </div>
        ) : null}
        <ResponsiveBlockGrid columnCount={columnCount} className="gap-x-6 gap-y-10">
          {items.map((item, index) => (
            <ResponsiveBlockGridItem key={`${item.heading}-${index}`}>
              <ImageContentGridCard
                {...item}
                effectiveAspectRatio={effectiveAspectRatio}
                imagePosition="bottom"
              />
            </ResponsiveBlockGridItem>
          ))}
        </ResponsiveBlockGrid>
      </div>
    </BlockContainer>
  );
};

ImageContentGridImageBottom.displayName = "ImageContentGrid::ImageContentGridImageBottom";
